module.exports = __webpack_public_path__ + "static/media/upgrade-dash.826f2145.png";